import React from 'react';
import { isEmpty, every, getOr } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Grid, Row, Col, Icon, Input, Button, DateRangePicker } from 'rsuite';

const Search = ({
  searchQuery,
  queryOptions,
  placeholder,
  onChange,
  onSubmit,
  onClear,
  isFetching
}) => {
  const handleOnChangeQuery = q => {
    onChange({ ...searchQuery, q });
  };
  const handleKeyPressQuery = ({ key }) => {
    const { q } = searchQuery;
    if (key === 'Enter' && q) onSubmit(queryOptions);
  };
  const handleOnChangeOutreachDate = outreachOn => {
    onChange({ ...searchQuery, outreachOn });
  };
  const hasQuery = !every(isEmpty, searchQuery);

  return (
    <Grid fluid>
      <Row gutter={16}>
        <Col xs={5}>
          <Input
            value={getOr('', 'q', queryOptions)}
            onChange={handleOnChangeQuery}
            style={{ paddingLeft: 10 }}
            placeholder={placeholder}
            disabled={isFetching}
            onKeyPress={handleKeyPressQuery}
          />
        </Col>
        <Col xs={5}>
          <DateRangePicker
            style={{ width: '100%' }}
            value={searchQuery.outreachOn}
            placeholder="Outreach Date Range"
            onChange={handleOnChangeOutreachDate}
            disabled={isFetching}
          />
        </Col>
        <Col xs={6} style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Button
            color="green"
            style={{ borderBottom: 'none', marginRight: 10 }}
            disabled={!hasQuery || isFetching}
            onClick={() => onSubmit(queryOptions)}
          >
            <Icon icon="search" /> Search
          </Button>
          <Button
            style={{ borderBottom: 'none', marginRight: 10 }}
            disabled={isFetching}
            onClick={onClear}
          >
            <Icon icon="refresh" /> Reset
          </Button>
        </Col>
      </Row>
    </Grid>
  );
};

Search.propTypes = {
  placeholder: PropTypes.string.isRequired,
  searchQuery: PropTypes.shape({
    q: PropTypes.string,
    outreachOn: PropTypes.string
  }).isRequired,
  queryOptions: PropTypes.shape({}),
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired
};

Search.defaultProps = {
  queryOptions: {}
};

export default Search;
